"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraOptions = void 0;
// external
const React = require("react");
// local
const Button_1 = require("../../../Button");
const Icon_1 = require("../../../Icon");
const standardSizes_1 = require("../../../../../../types/standardSizes");
// css
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles);
const CameraOptions = ({ onPhotoRejected, onPhotoAccepted, optionsState, showToggleCamera, onCameraToggle, onTakePhoto }) => {
    switch (optionsState) {
        case "takePhoto": {
            return (React.createElement("div", { className: css("options"), "data-test": "take-photo" },
                React.createElement(Button_1.Button, { onClick: onTakePhoto, disableOnSuccess: false }, "Take Photo"),
                showToggleCamera && (React.createElement(Icon_1.Icon, { name: "switch-camera", size: standardSizes_1.TStandardSizes.Small, onClick: onCameraToggle }))));
        }
        case "confirmPhoto": {
            return (React.createElement("div", { className: css("options"), "data-test": "confirm-photo" },
                React.createElement(Icon_1.Icon, { name: "close-hollow", size: standardSizes_1.TStandardSizes.ExtraSmall, onClick: onPhotoRejected }),
                React.createElement(Icon_1.Icon, { name: "tick", size: standardSizes_1.TStandardSizes.ExtraSmall, onClick: onPhotoAccepted })));
        }
    }
};
exports.CameraOptions = CameraOptions;
//# sourceMappingURL=index.js.map